/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled';
import { Link as RouterLink } from 'react-router-dom';

import logo from '../../images/logo.svg';
import { Button, colors, Container } from '../../ui';

const Link = styled('div')(({ active }) => ({
  height: '100%',
  borderBottomWidth: 2,
  borderBottomStyle: 'solid',
  padding: 20,
  alignItems: 'center',
  justifyContent: 'center',
  cursor: 'pointer',
  fontFamily: 'Open Sans',
  fontWeight: 600,
  fontSize: 16,
  lineHeight: '22px',
  transition: 'all .2s',

  borderBottomColor: active ? colors.blue : 'transparent',
  pointerEvents: active ? 'none' : 'all',
  color: active ? colors.blue : colors.black,
  ':hover': { borderBottomColor: colors.blue, color: colors.blue },
}));

const HeaderDesktop = ({ activeSection, scrollTo, openTariffs }) => (
  <Container
    css={{
      position: 'fixed',
      top: 0,
      borderBottom: `1px solid ${colors.black}`,
      height: 83,
      zIndex: 5,
      background: '#fff !important',
      boxShadow: `0px 2px 2px rgba(50, 50, 71, 0.06), 0px 2px 4px rgba(50, 50, 71, 0.06)`,
    }}
  >
    <header
      css={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        position: 'relative',
        height: '100%',
      }}
    >
      <img src={logo} />

      <nav css={{ display: 'flex', height: 'calc(100% + 2px)' }}>
        <Link onClick={() => scrollTo(1)} active={activeSection === 1}>
          Обзор
        </Link>
        <Link onClick={() => scrollTo(2)} active={activeSection === 2}>
          Отзывы
        </Link>
        <Link onClick={() => scrollTo(3)} active={activeSection === 3}>
          Кейсы
        </Link>
        <Link onClick={openTariffs}>Тарифы</Link>
      </nav>

      {/* <RouterLink to="/lk" target="_blank"> */}
      <Button onClick={() => window.open('https://vk-boss-light.web.app/guide', '_blank')}>
        Личный Кабинет
      </Button>
      {/* </RouterLink> */}
    </header>
  </Container>
);

export default HeaderDesktop;
